import { forwardRef, type SVGProps } from 'react'

interface PriceCheckIconProps extends SVGProps<SVGSVGElement> {}

export const PriceCheckIcon = forwardRef<SVGSVGElement, PriceCheckIconProps>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="currentColor"
        {...props}
      >
        <path d="M260-361v-40H160v-80h200v-80H200q-17 0-28.5-11.5T160-601v-160q0-17 11.5-28.5T200-801h60v-40h80v40h100v80H240v80h160q17 0 28.5 11.5T440-601v160q0 17-11.5 28.5T400-401h-60v40h-80zm298 240L388-291l56-56 114 114 226-226 56 56-282 282z" />
      </svg>
    )
  },
)

PriceCheckIcon.displayName = 'PriceCheckIcon'
